import React, { useState } from 'react';
import Slider from "react-slick";
import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";
import { A1AdditionalAssets, A1ContractualData, A2AdditionalAssets, A2ContractualData, A3AdditionalAssets, A3ContractualData, show1Data, show2Data, show3Data, show4Data, show5Data, show6Data, show7Data, show8Data } from "../RandomData/imageData";
import "../HomeComponent/CalendarStyle.css";
import { formattedDate } from '../../Helper/GlobalHelperFunction';


const ShowDetailsComponent = (props) => {
    var result
    const data = props.id;
    if (props.id === "show1Data") {
        result = show1Data;
        if (result.area1 > 0 && result.area1 <= 20) {
            var contractAsset = A1ContractualData.imageData;
        }
        else if (result.area1 >= 21 && result.area1 <= 55) {
            var contractAsset = A2ContractualData.imageData;
        }
        else {
            var contractAsset = A3ContractualData.imageData;
        }
    }
    else if (props.id === "show2Data") {
        result = show2Data;
        if (result.area1 > 0 && result.area1 <= 20) {
            var contractAsset = A1ContractualData.imageData;
            var additionalAssets = A1AdditionalAssets.imageData;
        }
        else if (result.area1 >= 21 && result.area1 <= 55) {
            var contractAsset = A2ContractualData.imageData;
            var additionalAssets = A2AdditionalAssets.imageData;
        }
        else {
            var contractAsset = A3ContractualData.imageData;
            var additionalAssets = A3AdditionalAssets.imageData;
        }
    }
    else if (props.id === "show3Data") {
        result = show3Data;
        if (result.area1 > 0 && result.area1 <= 20) {
            var contractAsset = A1ContractualData.imageData;
            var additionalAssets = A1AdditionalAssets.imageData;
        }
        else if (result.area1 >= 21 && result.area1 <= 55) {
            var contractAsset = A2ContractualData.imageData;
            var additionalAssets = A2AdditionalAssets.imageData;
        }
        else {
            var contractAsset = A3ContractualData.imageData;
            var additionalAssets = A3AdditionalAssets.imageData;
        }
    }
    else if (props.id === "show4Data") {
        result = show4Data;
        if (result.area1 > 0 && result.area1 <= 20) {
            var contractAsset = A1ContractualData.imageData;
            var additionalAssets = A1AdditionalAssets.imageData;
        }
        else if (result.area1 >= 21 && result.area1 <= 55) {
            var contractAsset = A2ContractualData.imageData;
            var additionalAssets = A2AdditionalAssets.imageData;
        }
        else {
            var contractAsset = A3ContractualData.imageData;
            var additionalAssets = A3AdditionalAssets.imageData;
        }
    }
    else if (props.id === "show5Data") {
        result = show5Data;
        if (result.area1 > 0 && result.area1 <= 20) {
            var contractAsset = A1ContractualData.imageData;
            var additionalAssets = A1AdditionalAssets.imageData;
        }
        else if (result.area1 >= 21 && result.area1 <= 55) {
            var contractAsset = A2ContractualData.imageData;
            var additionalAssets = A2AdditionalAssets.imageData;
        }
        else {
            var contractAsset = A3ContractualData.imageData;
            var additionalAssets = A3AdditionalAssets.imageData;
        }
    }
    else if (props.id === "show6Data") {
        result = show6Data;
        if (result.area1 > 0 && result.area1 <= 20) {
            var contractAsset = A1ContractualData.imageData;
            var additionalAssets = A1AdditionalAssets.imageData;
        }
        else if (result.area1 >= 21 && result.area1 <= 55) {
            var contractAsset = A2ContractualData.imageData;
            var additionalAssets = A2AdditionalAssets.imageData;
        }
        else {
            var contractAsset = A3ContractualData.imageData;
            var additionalAssets = A3AdditionalAssets.imageData;
        }
    }
    else if (props.id === "show7Data") {
        result = show7Data;
        if (result.area1 > 0 && result.area1 <= 20) {
            var contractAsset = A1ContractualData.imageData;
            var additionalAssets = A1AdditionalAssets.imageData;
        }
        else if (result.area1 >= 21 && result.area1 <= 55) {
            var contractAsset = A2ContractualData.imageData;
            var additionalAssets = A2AdditionalAssets.imageData;
        }
        else {
            var contractAsset = A3ContractualData.imageData;
            var additionalAssets = A3AdditionalAssets.imageData;
        }
    }
    else if (props.id === "show8Data") {
        result = show8Data;
        if (result.area1 > 0 && result.area1 <= 20) {
            var contractAsset = A1ContractualData.imageData;
            var additionalAssets = A1AdditionalAssets.imageData;
        }
        else if (result.area1 >= 21 && result.area1 <= 55) {
            var contractAsset = A2ContractualData.imageData;
            var additionalAssets = A2AdditionalAssets.imageData;
        }
        else {
            var contractAsset = A3ContractualData.imageData;
            var additionalAssets = A3AdditionalAssets.imageData;
        }
    }


    // const additionalAssets = result.imageData.filter((x) => x.isAdditional === true);
    // const contractAsset = result.imageData.filter((x) => x.isAdditional === false && x.isRental === false);
    const rentalAssets = result.imageData


    const [showModal, setShowModal] = useState(false);
    const [currentSliderIndex, setCurrentSliderIndex] = useState(null);
    const [activeAssetType, setActiveAssetType] = useState(null);

    const sliderSettings = {
        dots: true,
        infinite: true,
        speed: 100,
        slidesToShow: 1,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1024, // Tablet and smaller screens
                settings: {
                    arrows: false, // Disable arrows
                },
            },
            {
                breakpoint: 768, // Mobile screens
                settings: {
                    arrows: false, // Disable arrows
                },
            },
        ],
    };


    const handleSliderClick = (sliderIndex, assetType) => {
        // setCurrentSliderIndex(sliderIndex);
        // setActiveAssetType(assetType); 
        // setShowModal(true);
        setActiveAssetType(assetType); // "contract", "rental", or "additional"
        setCurrentSliderIndex(sliderIndex);
        setShowModal(true);
    }
    const closeModal = () => {
        setShowModal(false);
        setCurrentSliderIndex(null);
        setActiveAssetType(null); // Reset the asset type
    };

    const getAssetData = () => {

        if (activeAssetType === "contract") {
            return contractAsset[currentSliderIndex];
        } else if (activeAssetType === "rental") {
            return rentalAssets[currentSliderIndex];
        } else {
            return additionalAssets[currentSliderIndex];
        }
    }


    return (
        <div className='homeBack' style={{ backgroundColor: "rgb(9 24 59)" }}>
            <div className="mb-3 py-sm-2 py-1 px-sm-4 px-2" style={{ position: "sticky", top: "0", zIndex: "11", margin: "0px", backgroundColor: "rgb(9 24 59)", padding: "0px" }}>
                <div className="col-sm-12 p-1 d-flex justify-content-center flex-wrap">
                    <div className="col-sm-8 col-12  order-sm-first col-md-10 d-flex flex-wrap align-items-center justify-content-between">
                        <div className="col-sm-3 col-3">
                            <img src="/assets/logo/arrow-left-circle.svg" onClick={() => { props.navigate(-1) }} className='back ps-sm-3 ps-1' alt="" />
                        </div>
                        <div className="col-sm-9 col-9 text-light h2 d-flex justify-content-sm-center justify-content-end">
                            {result.showName}
                        </div>
                    </div>
                    <div className="col-sm-4 col-7 col-md-2 mb-2 order-first  d-flex align-items-center">
                        <img src="/assets/logo/airBus.png" onClick={() => { window.location.href = "/" }} alt="" className="img-fluid pe-4" style={{ cursor: "pointer" }} />
                    </div>
                </div>
            </div>
            <>
                <div className="container-fluid  p-2 px-sm-4">
                    <form className='p-sm-4 p-2'>
                        <div className="row">
                            <div className="col-sm-12 d-flex flex-wrap">
                                <div className="col-sm-5 col-12 ">
                                    <div className="form-group mb-2">
                                        <label ><b className='text-light'>Show Name</b></label>
                                        <input type="text" readOnly className="form-control" value={result.showName} name='showName' id="exampleInputEmail1" placeholder="Enter Show Name" />
                                    </div>
                                    <div className="form-group mb-2">
                                        <label ><b className='text-light'>Start Date</b></label>
                                        <input type="text" readOnly className="form-control" value={formattedDate(result.startDate)} name='startDate' />
                                    </div>
                                </div>
                                <div className="col-sm-2 col-12  justify-content-center align-items-center d-flex">
                                    <div className="col-sm-5 col-4 border border-5 border-primary justify-content-center bg-light align-items-center d-flex" style={{ borderRadius: "100%", minHeight: "80px", width: "80px" }}>
                                        <h1 className='mt-2' style={{ color: "rgb(9 24 59)" }}><b>{result.type}</b></h1>
                                    </div>
                                </div>
                                <div className="col-sm-5 col-12 ">
                                    <div className="col-12 d-flex">
                                        <div className="col-sm-6">
                                            <div className="form-group mb-2">
                                                <label ><b className='text-light'>Location</b></label>
                                                <input type="text" readOnly className="form-control" value={result.location} name='location' placeholder="Enter Location" />
                                            </div>
                                        </div>
                                        <div className="col-sm-6">
                                            <div className="form-group mb-2">
                                                <label ><b className='text-light'>Area</b></label>
                                                <input type="text" readOnly className="form-control" value={result.area} name='area' placeholder="Enter Area" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-group mb-2">
                                        <label ><b className='text-light'>End Date</b></label>
                                        <input type="text" className="form-control" readOnly value={formattedDate(result.endDate)} name='endDate' />
                                    </div>
                                </div>
                            </div>

                            <span className="col-sm-12 text-light mb-2" style={{ boxShadow: "1px -16px 7px #ffff", height: "10px", marginTop: "50px", borderRadius: "0 10px 0 0" }}></span>
                            <div className="col-sm-12 mt-3">
                                <div className="col-sm-12 mb-1">
                                    <div className="col-sm-5 col-md-3 p-1 text-center bg-primary text-light" style={{ borderRadius: "0 18px 0 0" }}>
                                        <h4 className='d-flex mt-1 px-2'>Contractual Assets<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" stroke='white' strokeWidth={1} fill="currentColor" className="ms-2 mt-1 bi bi-chevron-down" style={{ fontWeight: "20px" }} viewBox="0 0 16 16">
                                            <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708" />
                                        </svg></h4>
                                    </div>
                                </div>
                                {contractAsset.length !== 0 ? <>     <div className="col-sm-12 bg-light d-flex flex-lg-wrap p-3 " style={{ borderRadius: "0 20px 20px 0", overflow: "auto" }}>
                                    {contractAsset.map((asset, sliderIndex) => (

                                        <div className="col-lg-3 col-md-6 col-sm-7 col-11">
                                            <div className="card shadow-lg mx-3 m-2 mt-3 show" style={{ backgroundColor: "#fafbff" }}>
                                                <Slider {...sliderSettings}>
                                                    {asset.images.map((image, imageIndex) => (
                                                        <div
                                                            className='d-flex justify-content-center'
                                                            key={imageIndex}
                                                        >
                                                            <img src={image.src} alt={image.alt} key={sliderIndex} className='img-fluid'
                                                                onClick={() => handleSliderClick(sliderIndex, "contract")}
                                                                style={{ width: "200px", height: "150px", cursor: "pointer" }} />
                                                        </div>
                                                    ))}
                                                </Slider>
                                                <div className="card-body scrollStyle p-4">
                                                    <p className='h6 mb-0'><b className='text-style'>{asset.title}</b></p>
                                                    <div className=' w-100' style={{ overflowX: "auto" }}>
                                                        {asset.length === "" && asset.height === "" && asset.bredth === "" ? <h6 className='text-style'>Standard Size</h6> : <table className='table table-bordered mt-2 mb-0' >
                                                            <thead>
                                                                <tr>
                                                                    <th className='p-1 text-center'>
                                                                        L
                                                                    </th>
                                                                    <th className='p-1 text-center' >
                                                                        B
                                                                    </th>
                                                                    <th className='p-1 text-center' >
                                                                        H
                                                                    </th>

                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr>
                                                                    <td className='p-1 text-center'>{asset.length !== "" ? <>{asset.length}</> : "-"}</td>
                                                                    <td className='p-1 text-center' >{asset.bredth !== "" ? <>{asset.bredth}</> : "-"}</td>
                                                                    <td className='p-1 text-center'>{asset.height !== "" ? <>{asset.height}</> : "-"}</td>
                                                                </tr>
                                                            </tbody>
                                                        </table>}
                                                    </div>
                                                    <div className='card-text'><b className='text-style'>Qty.-</b> {asset.quantity}</div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                                </> : <div className='col-sm-12 bg-light p-3' style={{ borderRadius: "0 20px 20px 0" }}><h3>No Contractual Assets</h3></div>}
                            </div>


                            <span className="col-sm-12 text-light mb-2" style={{ boxShadow: "1px -16px 7px #ffff", height: "10px", marginTop: "50px", borderRadius: "0 10px 0 0" }}></span>
                            <div className="col-sm-12 mt-3">
                                <div className="col-sm-12 mb-1 d-flex">
                                    <div className="col-sm-5 col-md-3 p-2 text-center bg-primary text-light" style={{ borderRadius: "0 10px 0 0" }}>
                                        <h4 className='d-flex mt-1 px-2'>Additional Assets<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" stroke='white' strokeWidth={1} fill="currentColor" className="ms-2 mt-1 bi bi-chevron-down" style={{ fontWeight: "20px" }} viewBox="0 0 16 16">
                                            <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708" />
                                        </svg></h4>
                                    </div>
                                    <div className="col-sm-7 text-light d-flex align-items-center h4 px-sm-3 flex-wrap">
                                        <div className=' d-flex  justify-content-center align-items-center m-1'>
                                            Note: Quantity n depicts any number of asset.
                                        </div>

                                    </div>
                                </div>
                                {additionalAssets.length !== 0 ? <>    <div className="col-sm-12 bg-light d-flex flex-lg-wrap p-3 " style={{ borderRadius: "0 20px 20px 0", overflow: "auto" }}>
                                    {additionalAssets.map((asset, sliderIndex) => (

                                        <div className="col-lg-3 col-md-6 col-sm-7 col-11">
                                            <div className="card shadow-lg mx-3 m-2 mt-3 show" style={{ backgroundColor: "#fafbff" }}>
                                                <Slider {...sliderSettings}>
                                                    {asset.images.map((image, imageIndex) => (
                                                        <div
                                                            className='d-flex justify-content-center'
                                                            key={imageIndex}
                                                        >
                                                            <img src={image.src} alt={image.alt} key={sliderIndex} className='img-fluid'
                                                                onClick={() => handleSliderClick(sliderIndex, "additional")}
                                                                style={{ width: "200px", height: "150px", cursor: "pointer" }} />
                                                        </div>
                                                    ))}
                                                </Slider>
                                                <div className="card-body scrollStyle p-4">
                                                    <p className='h6 mb-0'><b className='text-style'>{asset.title}</b></p>
                                                    <div className=' w-100' style={{ overflowX: "auto" }}>
                                                        {asset.length === "" && asset.height === "" && asset.bredth === "" ? <h6 className='text-style'>Standard Size</h6> : <table className='table table-bordered mt-2 mb-0' >
                                                            <thead>
                                                                <tr>
                                                                    <th className='p-1 text-center'>
                                                                        L
                                                                    </th>
                                                                    <th className='p-1 text-center' >
                                                                        B
                                                                    </th>
                                                                    <th className='p-1 text-center' >
                                                                        H
                                                                    </th>

                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr>
                                                                    <td className='p-1 text-center'>{asset.length !== "" ? <>{asset.length}</> : "-"}</td>
                                                                    <td className='p-1 text-center' >{asset.bredth !== "" ? <>{asset.bredth}</> : "-"}</td>
                                                                    <td className='p-1 text-center'>{asset.height !== "" ? <>{asset.height}</> : "-"}</td>
                                                                </tr>
                                                            </tbody>
                                                        </table>}
                                                    </div>
                                                    <div className='card-text'><b className='text-style'>Qty.-</b> {asset.quantity}</div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>


                                </> : <div className='col-sm-12 bg-light p-3' style={{ borderRadius: "0 20px 20px 0" }}><h3>No Additional Assets</h3></div>}
                            </div>


                            <span className="col-sm-12 text-light mb-2" style={{ boxShadow: "1px -16px 7px #ffff", height: "10px", marginTop: "50px", borderRadius: "0 10px 0 0" }}></span>
                            <div className="col-sm-12 mt-3">
                                <div className="col-sm-12 mb-1 d-flex flex-wrap">
                                    <div className="col-sm-4 col-md-3 p-1 text-center bg-primary text-light" style={{ borderRadius: "0 10px 0 0" }}>
                                        <h4 className='d-flex px-2 mt-1'>Final Assets<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" stroke='white' strokeWidth={1} fill="currentColor" className="ms-2 mt-1 bi bi-chevron-down" style={{ fontWeight: "20px" }} viewBox="0 0 16 16">
                                            <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708" />
                                        </svg></h4>
                                    </div>
                                    <div className="col-sm-7 text-light d-flex align-items-center h4 px-sm-3 flex-wrap">
                                        <div className=' d-flex  justify-content-center align-items-center m-1'>
                                            <div className='rounded ms-sm-3' style={{ width: "30px", height: "30px", backgroundColor: "rgb(211 233 220)" }}></div> <div className='ms-1'>Contract Assets</div>
                                        </div>
                                        <div className=' d-flex justify-content-center align-items-center m-1'>
                                            <div className='rounded  ms-sm-5' style={{ width: "30px", height: "30px", backgroundColor: "#fccaca" }}></div> <div className='ms-1'>Additional Assets</div>
                                        </div>
                                    </div>
                                </div>
                                {rentalAssets.length !== 0 ? <>    <div className="col-sm-12 bg-light d-flex flex-lg-wrap p-3 " style={{ borderRadius: "0 20px 20px 0", overflow: "auto" }}>
                                    {rentalAssets.map((asset, sliderIndex) => (

                                        <div className="col-lg-3 col-md-6 col-sm-7 col-11">
                                            {asset.isAdditional === false && asset.isRental === false ?
                                                <div className="card shadow-lg mx-3 m-2 mt-3 show " style={{ backgroundColor: "rgb(211 233 220)" }}>
                                                    <Slider {...sliderSettings}>
                                                        {asset.images.map((image, imageIndex) => (
                                                            <div
                                                                className='d-flex justify-content-center'
                                                                key={imageIndex}
                                                            >
                                                                <img src={image.src} alt={image.alt} key={sliderIndex} className='img-fluid'
                                                                    onClick={() => handleSliderClick(sliderIndex, "rental")}
                                                                    style={{ width: "200px", height: "150px", cursor: "pointer" }} />
                                                            </div>
                                                        ))}
                                                    </Slider>
                                                    <div className="card-body scrollStyle p-4">
                                                        <p className='h6 mb-0'><b className='text-style'>{asset.title}</b></p>
                                                        <div className=' w-100' style={{ overflowX: "auto" }}>
                                                            {asset.length === "" && asset.height === "" && asset.bredth === "" ? <h6 className='text-style'>Standard Size</h6> : <table className='table table-bordered mt-2 mb-0' >
                                                                <thead>
                                                                    <tr>
                                                                        <th className='p-1 text-center'>
                                                                            L
                                                                        </th>
                                                                        <th className='p-1 text-center' >
                                                                            B
                                                                        </th>
                                                                        <th className='p-1 text-center' >
                                                                            H
                                                                        </th>

                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <tr>
                                                                        <td className='p-1 text-center'>{asset.length !== "" ? <>{asset.length}</> : "-"}</td>
                                                                        <td className='p-1 text-center' >{asset.bredth !== "" ? <>{asset.bredth}</> : "-"}</td>
                                                                        <td className='p-1 text-center'>{asset.height !== "" ? <>{asset.height}</> : "-"}</td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>}
                                                        </div>
                                                        <div className='card-text'><b className='text-style'>Qty.-</b> {asset.quantity}</div>
                                                    </div>
                                                </div> :
                                                <div className="card shadow-lg mx-3 m-2 mt-3 show " style={{ backgroundColor: "#fccaca" }}>
                                                    <Slider {...sliderSettings}>
                                                        {asset.images.map((image, imageIndex) => (
                                                            <div
                                                                className='d-flex justify-content-center'
                                                                key={imageIndex}
                                                            >
                                                                <img src={image.src} alt={image.alt} key={sliderIndex} className='img-fluid'
                                                                    onClick={() => handleSliderClick(sliderIndex, "rental")}
                                                                    style={{ width: "200px", height: "150px", cursor: "pointer" }} />
                                                            </div>
                                                        ))}
                                                    </Slider>
                                                    <div className="card-body scrollStyle p-4">
                                                        <p className='h6 mb-0'><b className='text-style'>{asset.title}</b></p>
                                                        <div className=' w-100' style={{ overflowX: "auto" }}>
                                                            {asset.length === "" && asset.height === "" && asset.bredth === "" ? <h6 className='text-style'>Standard Size</h6> : <table className='table table-bordered mt-2 mb-0' >
                                                                <thead>
                                                                    <tr>
                                                                        <th className='p-1 text-center'>
                                                                            L
                                                                        </th>
                                                                        <th className='p-1 text-center' >
                                                                            B
                                                                        </th>
                                                                        <th className='p-1 text-center' >
                                                                            H
                                                                        </th>

                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <tr>
                                                                        <td className='p-1 text-center'>{asset.length !== "" ? <>{asset.length}</> : "-"}</td>
                                                                        <td className='p-1 text-center' >{asset.bredth !== "" ? <>{asset.bredth}</> : "-"}</td>
                                                                        <td className='p-1 text-center'>{asset.height !== "" ? <>{asset.height}</> : "-"}</td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>}
                                                        </div>
                                                        <div className='card-text'><b className='text-style'>Qty.-</b> {asset.quantity}</div>
                                                    </div>
                                                </div>}
                                        </div>
                                    ))}
                                </div>


                                </> : <div className='col-sm-12 bg-light p-3' style={{ borderRadius: "0 20px 20px 0" }}><h3>No Assets Finalised</h3></div>}
                            </div>


                        </div>
                    </form>

                    {/* Modal */}
                    {showModal && currentSliderIndex !== null && (
                        <div className="modal show d-block  " tabIndex="-1" style={{ backgroundColor: "rgba(0, 0, 0, 0.5)", zIndex: "12" }}>
                            <div className="modal-dialog align-self-center imageModal modal-lg ">
                                <div className="modal-content ">
                                    <div className="modal-header">
                                        <h5 className="modal-title">
                                            {getAssetData().title}
                                            {/* {activeAssetType === "contract"
                                                ? contractAsset[currentSliderIndex].title
                                                : additionalAssets[currentSliderIndex].title} */}
                                        </h5>
                                        <button type="button" className="btn-close" onClick={closeModal}></button>
                                    </div>
                                    <div className="modal-body mb-4">
                                        <Slider {...sliderSettings}>
                                            {getAssetData().images.map((image, imageIndex) => (
                                                <div className="d-flex justify-content-center py-2 border" key={imageIndex}>
                                                    <Zoom>
                                                        <img
                                                            src={image.src}
                                                            alt={image.alt}
                                                            style={{ width: "320px", height: "320px", objectFit: "contain" }}
                                                        />
                                                    </Zoom>
                                                </div>
                                            ))}
                                        </Slider>

                                    </div>
                                    <div className="modal-footer">
                                        <button type="button" className="btn btn-secondary" onClick={closeModal}>
                                            Close
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </>
        </div>
    );
};

export default ShowDetailsComponent;
